var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "modal fixed w-full h-full top-0 left-0 flex items-center justify-center p-10",
      class: _vm.isShowingModal ? "z-50" : "opacity-0 pointer-events-none",
      attrs: { id: "modalAddUser" }
    },
    [
      _c("div", {
        staticClass:
          "modal-overlay absolute w-full h-full bg-gray-900 opacity-50"
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "modal-container\n        bg-white w-11/12 md:max-w-none mx-auto rounded shadow-lg z-50 overflow-y-auto"
        },
        [
          !_vm.isHideToggle
            ? _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.toggleModal()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "modal-close\n               absolute\n               top-0\n               right-0\n               cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50"
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "fill-current text-white",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "18",
                            height: "18",
                            viewBox: "0 0 18 18"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-sm" }, [_vm._v("(Esc)")])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "modal-content py-4 text-left px-6" }, [
            _c(
              "div",
              { staticClass: "flex justify-between items-center pb-3" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "modal-close cursor-pointer z-50" }, [
                  !_vm.isHideToggle
                    ? _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.toggleModal()
                            }
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "fill-current text-black",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex w-full overflow-y-auto overflow-x-hidden border text-black rounded-r-md",
                staticStyle: { "max-height": "50vh" }
              },
              [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.contentTermsOfCondition) }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-wrap justify-center text-black pt-2" },
              [
                _c("div", { staticClass: "w-full text-center p-5" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.agreement,
                        expression: "agreement"
                      }
                    ],
                    attrs: { type: "checkbox", disabled: _vm.isLoading },
                    domProps: {
                      checked: Array.isArray(_vm.agreement)
                        ? _vm._i(_vm.agreement, null) > -1
                        : _vm.agreement
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.agreement,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.agreement = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.agreement = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.agreement = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(
                    " I have read and accepted the Terms & Conditions\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "modal-close px-4 bg-blue-500 p-3 rounded-lg text-white hover:bg-blue-400",
                    class: !_vm.agreement
                      ? "opacity-50 cursor-not-allowed"
                      : "",
                    attrs: { disabled: !_vm.agreement },
                    on: {
                      click: function($event) {
                        return _vm.save()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.labelSaveButton) +
                        "\n          "
                    )
                  ]
                )
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-row" }, [
      _c("p", { staticClass: "text-2xl font-bold" }, [
        _vm._v("Terms and Conditions")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "font-bold" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09924f7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09924f7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/ModalTermAndConditions.vue
// module id = null
// module chunks = 